module.exports = __webpack_public_path__ + "static/media/ScrollBarRight.2f246dad.svg";